import { render, staticRenderFns } from "./Comprovante.vue?vue&type=template&id=257ce817&scoped=true"
import script from "./Comprovante.vue?vue&type=script&lang=js"
export * from "./Comprovante.vue?vue&type=script&lang=js"
import style0 from "./Comprovante.vue?vue&type=style&index=0&id=257ce817&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257ce817",
  null
  
)

export default component.exports